import React from 'react';
import { SPONSORSHIP_BONUSES } from '../../../../../shared/helpers/sponsorshipHelper';

const SponsorshipBonusesTable = ({ className = 'text-sm' }) => {
  return (
    <table className={className} data-testid='SponsorshipBonusesTable'>
      <thead>
        <tr className='text-ih-indigo-60'>
          <th className='font-normal text-left pr-6 pb-1'>Bien vendu</th>
          <th className='font-normal text-right pb-1'>Prime</th>
        </tr>
      </thead>
      <tbody className='divide-y divide-ih-blue-10'>
        {SPONSORSHIP_BONUSES.map(({ label, amount }) => (
          <tr key={label}>
            <td className='pr-6 py-1'>{label}</td>
            <td className='text-right font-semibold text-ih-blue py-1'>{amount.toLocaleString('fr-FR')} €</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SponsorshipBonusesTable;
